'use strict';

var clientSideValidation = require('../components/clientSideValidation');

module.exports = {
    inputFocus: function () {
        $('.check-order-cta-js').on('click', function () {
            var trackOrderForm = $('.trackorder-form-section .trackorder');
            let formObj = trackOrderForm.get(0);
            let formValid = clientSideValidation.functions.validateForm(formObj);

            if (!formValid) {
                $('input.is-invalid').first()?.focus();
            }
        });
    },
};